import React from 'react'
import ContactsContainer from '../../../Components/Applications/Contacts'

export default function Contacts() {
    return (
        <div className='page-body'>
            <ContactsContainer />
        </div>
    )
}
